import axios from 'axios';
import { MODULES_BASE_URLS } from 'src/common/constants';


export default class DashboardService {
	static instance;

	static getInstance() {
		if (!DashboardService.instance) {
			DashboardService.instance = new DashboardService();
		}

		return DashboardService.instance;
	}

    async fetchSummary(params = {}, module){
        const response = await axios.get(`${MODULES_BASE_URLS[module]}/dashboard/summary`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchHeatmap(params = {}, module){
        const response = await axios.get(`${MODULES_BASE_URLS[module]}/dashboard/heatmap`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchCategories(params = {}, module){
        const response = await axios.get(`${MODULES_BASE_URLS[module]}/dashboard/categories`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchTasksByDate(params = {}, module){
        const response = await axios.get(`${MODULES_BASE_URLS[module]}/dashboard/tasks-by-date`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchCasesByDate(params = {}, module){
        const response = await axios.get(`${MODULES_BASE_URLS[module]}/dashboard/cases-by-date`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }
}
